// Google Analytics utility
// To use: Set REACT_APP_GA_MEASUREMENT_ID in your .env file
// Example: REACT_APP_GA_MEASUREMENT_ID=G-XXXXXXXXXX

let gaInitialized = false;

export const initGA = () => {
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  
  if (!measurementId || gaInitialized) {
    return;
  }

  // Load Google Analytics script
  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script1);

  // Initialize gtag
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;

  gtag('js', new Date());
  gtag('config', measurementId, {
    page_path: window.location.pathname,
  });

  gaInitialized = true;
};

export const trackPageView = (path) => {
  if (!window.gtag || !process.env.REACT_APP_GA_MEASUREMENT_ID) {
    return;
  }

  window.gtag('config', process.env.REACT_APP_GA_MEASUREMENT_ID, {
    page_path: path,
  });
};

export const trackEvent = (action, category, label, value) => {
  if (!window.gtag || !process.env.REACT_APP_GA_MEASUREMENT_ID) {
    return;
  }

  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value: value,
  });
};

export const trackLogin = (userRole) => {
  trackEvent('login', 'User', userRole);
};

export const trackLogout = () => {
  trackEvent('logout', 'User', 'logout');
};

export const trackNavigation = (pageName) => {
  trackEvent('navigation', 'Navigation', pageName);
};
